import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {
    AutocompleteArrayInput,
    BooleanInput,
    LongTextInput,
    ReferenceArrayInput,
    showNotification,
    Title,
    translate
} from 'react-admin';
import {NotifyForm, showErrorNotify} from '../../components';
import env from '../../env';
import {downloadFilePost} from "../../components/FileDownload";
import axiosInstance from "../../api/axios";
import TreeCheckBoxCustomInput from "../../components/TreeCheckBoxCustomInput";
import utils from "../../utils/utils";
import {compose} from "redux";
import {connect} from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import moment from "moment";

class BillBatchItemMergeNotify extends React.Component {
    state = {
        loading: false,
        changeMonth: false,
        batchIds: [],
        customerIds: [],
        note: '',
        displayDueDate: true,
        month: moment().format('YYYY-MM-DD'),
        customers: [],
        params: {
            batchIds: [],
            customerIds: [],
            note: '',
            displayDueDate: true
        }
    };

    componentDidMount(prevProps, prevState, snapshot) {
        axiosInstance
            .get('/api/customersByUnits?studentOnly=true')
            .then(rs => this.setState({customers: rs.data.content || []}))
    }

    getReportUrl = (fullDay, allStudent) => {
        this.setState({loading: true})
        if (!this.state.params.note) {
            this.state.params.note = '';
        }
        const data = {
            fullDayOnly: fullDay,
            allStudent: allStudent,
            displayDueDate: this.state.params.displayDueDate,
            note: this.state.params.note,
            batchIds: this.state.params.batchIds,
            customerIds: this.state.params.customerIds
        }
        downloadFilePost(`${env.baseURL}/reports/in-tb-hp-gop-ke-hoach`, 'thong_bao_hoc_phi.xlsx', data)
            .then(() => {
                this.setState({loading: false})
            })
            .catch(() => {
                this.setState({loading: false})
            })
    }
    notifyAllStudents = () => {
        if (this.state.params.customerIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách học sinh")
            return;
        }
        if (!this.state.params.batchIds || this.state.params.batchIds.length === 0) {
            showErrorNotify("Vui lòng chọn kế hoạch")
            return;
        }
        this.getReportUrl(false, true)
    };

    fullDayOnly = () => {
        if (!this.state.params.customerIds || this.state.params.customerIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách học sinh")
            return;
        }
        if (!this.state.params.batchIds || this.state.params.batchIds.length === 0) {
            showErrorNotify("Vui lòng chọn kế hoạch")
            return;
        }
        this.getReportUrl(true, false)
    };

    notFullDayOnly = () => {
        if (!this.state.params.customerIds || this.state.params.customerIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách học sinh")
            return;
        }
        if (!this.state.params.batchIds || this.state.params.batchIds.length === 0) {
            showErrorNotify("Vui lòng chọn kế hoạch")
            return;
        }
        this.getReportUrl(false, false)
    };

    validate = (values) => {
        const errors = {};

        // Copy input values to params

        if (this.state.changeMonth) {
            this.setState({
                changeMonth: false,
                params: {
                    batchIds: [],
                    note: values.note,
                    displayDueDate: values.displayDueDate,
                    customerIds: values.customerIds,
                }
            })
        } else {
            this.setState({
                params: {
                    batchIds: values.batchIds,
                    note: values.note,
                    displayDueDate: values.displayDueDate,
                    customerIds: values.customerIds,
                }
            })
        }

        return errors;
    };

    onChangeMonth(e, value) {
        this.setState({
            month: value,
            changeMonth: true,
        });
    }

    render() {
        const {translate} = this.props;
        return (
            <Card>
                <Title title="resources.in-tb-hp-gop-ke-hoach.name"/>
                <CardContent>
                    <NotifyForm validate={this.validate}
                                allClazzes={this.notifyAllStudents}
                                fullDayClazzes={this.fullDayOnly}
                                notFullDayClazzes={this.notFullDayOnly}
                                params={this.state}
                                isLoading={this.state.loading}
                    >
                        <Grid container spacing={8} style={{marginBottom: 20}}>
                            <span>{translate("resources.in-tb-hp-gop-ke-hoach.reportNote")}</span>
                        </Grid>
                        <Grid container spacing={8}>
                            {/*<Grid item xs={12} sm={6}>*/}
                            {/*    <DateInput style={{width: '25%'}} label="resources.in-tb-hp-gop-ke-hoach.month"*/}
                            {/*               source="month" validate={required()} {...this.props}*/}
                            {/*               onChange={(e, value) => this.onChangeMonth(e, value)}/>*/}
                            {/*</Grid>*/}
                            <ReferenceArrayInput
                                source="batchIds"
                                label="resources.billBatches.name"
                                reference="billBatches"  {...this.props}
                            >
                                <AutocompleteArrayInput optionText={'displayDescription'}/>
                            </ReferenceArrayInput>
                            <Grid item xs={12} sm={6}>
                                <BooleanInput label="resources.in-tb-hp-gop-ke-hoach.displayDueDate"
                                              source="displayDueDate" {...this.props}  />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <LongTextInput label="resources.in-tb-hp-gop-ke-hoach.note"
                                               rows={5}
                                               style={{maxWidth: '90%'}}
                                               multiline
                                               source="note" {...this.props} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <label><b>Danh sách học sinh</b></label>
                                <div style={{width: 500, maxHeight: '300px', overflow: 'auto', marginTop: 10}}>
                                    <TreeCheckBoxCustomInput data={this.state.customers} expandTopLevel={true}
                                                             onChange={(value) => this.setState({
                                                                 params: {
                                                                     ...this.state.params,
                                                                     customerIds: utils.extractCustomerIdsV2(value)
                                                                 }
                                                             })}/>
                                </div>
                            </Grid>
                        </Grid>
                    </NotifyForm>

                </CardContent>
            </Card>
        )
    }
}

const styles = {}
export default compose(
    translate,
    connect(null, {showNotification}),
    withStyles(styles)
)(BillBatchItemMergeNotify)
